import axios from "axios";
import { ApiKey, liveURL } from "../constants/Consts";

const MAIN_URL = `${liveURL}/userDatabase`;

// ✅ Get all users from user_database
export async function getAllUsers(token) {
  try {
    const response = await axios.get(MAIN_URL, {
      headers: {
        token: token,
      },
    });
    return response.data;
  } catch (error) {
    console.log("Error fetching users:", error);
    return { success: false, message: "Error fetching users" };
  }
}

export async function getFields() {
    const response = await axios.get(`${MAIN_URL}/fields`);
    return response.data;
}

export async function saveFields(fields) {
    const response = await axios.post(`${MAIN_URL}/fields`, fields, {
        headers: { apikey: ApiKey },
    });
    return response.data;
}

export async function getData() {
    const response = await axios.get(`${MAIN_URL}/data`, {
        headers: { apikey: ApiKey },
    });
    return response.data;
}
